class RecipientFrom extends HTMLElement {
  constructor() {
    super()

    this.toggleCheckbox = this.querySelector('input[type="checkbox"]')
    this.fieldsWrapper = this.querySelector('.js-product-gift-card-form-fields')
    this.sendDateEl = this.querySelector('input[type="date"]')

    this.state = {
      open: true
    }

    if (this.fieldsWrapper) {
      this.fields = Array.from(this.fieldsWrapper.querySelectorAll('input, textarea'))
    }

    this.attachEvents()
    this.preventSelectPastDate()
  }

  attachEvents() {
    this.toggleCheckbox && this.toggleCheckbox.addEventListener('change', this.toggleForm.bind(this))
  }

  toggleForm(e) {
    if (this.state.open) {
      this.classList.remove('is-open')
      this.state.open = false
      this.disableAllFields()
    } else {
      this.classList.add('is-open')
      this.state.open = true
      this.enableAllFields()
    }
  }

  disableAllFields() {
    this.fields.forEach(field => (field.disabled = true))
  }

  enableAllFields() {
    this.fields.forEach(field => (field.disabled = false))
  }

  preventSelectPastDate() {
    if (!this.sendDateEl) return

    const dtToday = new Date()
    let month = dtToday.getMonth() + 1
    let day = dtToday.getDate()
    const year = dtToday.getFullYear()
    if(month < 10)
        month = '0' + month.toString()
    if(day < 10)
        day = '0' + day.toString()

    const maxDate = year + '-' + month + '-' + day
    this.sendDateEl.setAttribute('min', maxDate)
  }
}

customElements.define('recipient-form', RecipientFrom)
